import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import AnalyseIm from '../../../images/analysevis.jpg';

const Session16 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respResp1, setRespResp1] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour, et bienvenue dans notre dernière session !</h3>
            <p>
              Revenons ensemble sur tout ce que nous avons appris ces dernières
              semaines.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1GmXTLBWg4ZhJjFbPNM8gyqWMA11PEWY-Ikr2nJZJeDg"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Est-ce qu’un jeune de moins de 18 ans peut créer son association
                ?
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel value="oui" control={<Radio />} label="Oui" />
                <FormControlLabel value="non" control={<Radio />} label="Non" />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Lors de la dernière session, tu as décrit une scène visuelle dans
              laquelle il se passait beaucoup de choses.
            </p>
            <p>
              Maintenant, nous allons imaginer que tu dois expliquer à quelqu’un
              comment tu as observé cette scène.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>Pour rappel, voici l’image de la dernière fois. </p>
            <img
              src={AnalyseIm}
              alt="ImageAnalyse"
              style={{width: '45%', marginLeft: '20%'}}
            />
            <p>
              Maintenant, écris ci-dessous quelle stratégie tu as utilisé pour
              explorer cette image. Par exemple, peut-être que tu as regardé
              l’image plutôt de gauche à droite, de haut en bas, sans ordre
              particulier, ou certains objets avant les autres.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              id="regles"
              label="Tes conseils"
              variant="outlined"
              value={respResp1}
              onChange={(e) => {
                setRespResp1(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>Ça y est, nous avons terminé l’ensemble des séances.</p>
            <p>Un grand bravo pour ta participation et ton assiduité !</p>
            <p>
              Rendez-vous bientôt avec l’équipe de recherche pour faire une
              dernière séance de petits jeux, comme la première fois.
            </p>
            <p>Merci beaucoup !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Lors de la dernière session, tu as fait le résumé de ton action
                bénévole dans ce groupe pour Ella, la prochaine bénévole de
                l’association.
              </p>
              <p>
                Ella a une question pour toi : à toi d’essayer d’y répondre !
              </p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>Voici la question d’Ella :</p>
              {group.toString() === 'test_a' && (
                <p>
                  « Maintenant que tu as été bénévole pour cette association,
                  est-ce que cela t’a donné envie de t’engager encore plus pour
                  la cause de l’écologie ? Comment penses-tu pouvoir aider dans
                  ton quotidien ? »
                </p>
              )}
              {group.toString() === 'test_b' && (
                <p>
                  « Maintenant que tu as été bénévole pour cette association,
                  est-ce que cela t’a donné envie de t’engager encore plus pour
                  le soutien aux personnes hospitalisées ? Comment penses-tu
                  pouvoir aider dans ton quotidien ? »
                </p>
              )}
              {group.toString() === 'test_c' && (
                <p>
                  « Maintenant que tu as été bénévole pour cette association,
                  est-ce que cela t’a donné envie de t’engager encore plus pour
                  le soutien aux personnes en situation de pauvreté ? Comment
                  penses-tu pouvoir aider dans ton quotidien ? »
                </p>
              )}

              <p>
                Que souhaiterais-tu lui répondre ? Tu peux écrire ta réponse
                ci-dessous :
              </p>
              <TextField
                multiline
                fullWidth
                rows="4"
                label="Ta réponse"
                variant="outlined"
                value={respResp1}
                onChange={(e) => {
                  setRespResp1(e.target.value);
                }}
              />
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>Ça y est, nous avons terminé l’ensemble des séances.</p>
              <p>
                Un grand bravo pour ta participation et ton assiduité ! Nous
                espérons que cet engagement bénévole t’a plu et t’a donné envie
                de continuer à aider.
              </p>
              <p>
                Rendez-vous bientôt avec l’équipe de recherche pour faire une
                dernière séance de petits jeux, comme la première fois.{' '}
              </p>
              <p>Merci beaucoup!</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session16')
              .add({
                date: now,
                response: response,
                respQ: respResp1,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session16;
